export default function Logo({ className = "", variant = "default", imgClass = "h-[4.5rem]" }) {
  const base = variant === "white" ? "/fedari-logo-white" : "/fedari-logo";
  return (
    <div className={`flex items-center${className ? " " + className : ""}`} data-testid="logo">
      <picture>
        <source srcSet={`${base}.avif`} type="image/avif" />
        <source srcSet={`${base}.webp`} type="image/webp" />
        <img
          src={`${base}.png`}
          alt="Fedari Inspection"
          width={360}
          height={244}
          decoding="async"
          className={`${imgClass} w-auto object-contain`}
        />
      </picture>
    </div>
  );
}
